/**
 * Logo Component - Logo padronizado para toda a aplicação
 * Uses WebP with PNG fallback for optimal performance.
 * Small sizes use the lighter logo-sm asset.
 */

const SIZES = {
    sm: { height: 40, width: 'auto' },
    md: { height: 73, width: 'auto' },
    lg: { height: 125, width: 'auto' },
    xl: { height: 182, width: 'auto' },
};

// Use smaller asset for small renderings
const getSources = (size) => {
    if (size === 'sm') {
        return { webp: '/logo-sm.webp', png: '/logo-sm.png' };
    }
    if (size === 'md') {
        return { webp: '/logo-md.webp', png: '/logo.png' };
    }
    return { webp: '/logo.webp', png: '/logo.png' };
};

export default function Logo({ 
    size = 'md', 
    className = '',
    alt = 'RecepPet',
    onClick = null
}) {
    const dimensions = SIZES[size] || SIZES.md;
    const sources = getSources(size);
    
    return (
        <picture>
            <source srcSet={sources.webp} type="image/webp" />
            <img 
                src={sources.png}
                alt={alt}
                className={`object-contain ${className}`}
                style={{ 
                    height: `${dimensions.height}px`, 
                    width: dimensions.width,
                    maxWidth: '100%'
                }}
                onClick={onClick}
                loading={size === 'xl' ? 'eager' : 'lazy'}
                decoding="async"
                data-testid={`logo-${size}`}
            />
        </picture>
    );
}

export { Logo };
